import React from 'react';
import './../App.css';
import BlueTicket from '../Components/BlueTicket';
import Search from '../Components/Search';
import Article from '../Components/Article';
import Editor from '../Components/Editor';
import SideBar from '../Components/SideBar';
import methodsOneContext from '../Contexts/MethodsOne';
import GoodsContainer from '../Components/GoodsContainer'
import PartialSite1 from '../Components/PartialSite1';
import ScrollAnimation from 'react-animate-on-scroll';
import ContactBitkala from '../Components/ContactBitkala';


export default class App extends React.Component {
  constructor(props) {
    super(props);
    console.log(this.props.history.location.pathname);
  }

  state = {
    detailList: [],
    editId: -1
  }


  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  setDetailList(data) {

    this.setState(prevState => {
      return {
        detailList: data,
        editId: -1
      }
    })

  }

  editDetail(id) {
    this.setState(prevState => {
      return {
        editId: id
      }
    })
  }

  newEvent() {
    this.setState(prevState => {
      return {
        detailList: [{ Id: 0, Description: '', Tag: '' }],
        editId: 0
      }
    })

    console.log('رسsadadsadیدم');
    console.log(this.state);
    console.log(this.state.detailList);

  }

  render() {
    let detailList = this.state.detailList;
    let editId = this.state.editId;
    return (

      <>
        <div class="header_section">
          <ScrollAnimation animateIn="fadeIn">
            <div>
              <div class="container">
                <div class="maz_fulltext">
                  {/* <p>&nbsp;</p> */}
                  <h1>طراحی و تولید یک وب سایت حرفه ای&nbsp;</h1>
                  <p>یک وب سایت حرفه ای در پیشبرد اهداف کسب و کار شما بسیار موثر می باشد ، به طوری که به شدت می تواند کسب و کار شما را تحت تاثیر قرار دهد.چه بسا کسب کارهایی که وب سایت های غیر حرفه ای دارند و به علت سرعت لود پایین و بهینه نبودن برای موتور های جستجو بازدید کننده های کمی دارند و از رقبا عقب مانده اند و چه بسا کسب و کارهایی که پا گرفته اند اما وب سایتشان قابلیت رشد نداشته و مجبور می شود وب سایت را دوباره تولید و بار گذاری نمایند یا وب سایتهایی که به دلیل تکنولوژی پایین و بی کیفیت بودن کدنویسی درآن هزینه نگهداری بالا دارند .</p>
                  <p>اصولا یک سایت حرفه ای با آخرین متدولوژی روز طراحی می شود به صورتی که هم کاربران نهایی به راحتی با آن کار می کنند و به اصطلاح رابط کاربری خوبی دارد و هم از نظر فنی توسط متخصصان تایید می شود .</p>
                  <p>سایت های حرفه ای سایتهایی هستن که به صورت شخصی برای مشتریان و بر اساس نیاز آنها و آینده بیزینسی آنها طراحی می شود و زیر ساخت مناسب را برای اضافه کردن سرویسها و ماژول های جدید مناسب آن کسب و کار را دارا می باشند .</p>
                  <p>وب سایت های از قبل آماده ای که به ازای مشتریهای مختلف تغییرات ظاهری در انها به وجود می آورند نمی توانند با حد اکثر ظرفیت سخت افزار و یهنای باند کار کنند و معمولا بسیار سنگین هستن و تکنولوژی به کار رفته در آنها به روز نیست چون قبلا طراحی شده اند و بر اساس نیاز مشتری تغییراتی در آن صورت می پذیرد که بعضا به خاطر این که به روز طراحی نشده اند یا برای همان بیزینس خاص بهینه نشده اند ،اضافه کردن سرویسهای جدید و امکانات جدید به سایت به سختی صورت می پذیرد و امکان دارد کاراییه بقیه نرم افزار یا سایت مورد نظر را دچار مشکل نماید و این که معمولا با لود بسیار بالا به علت سنگینی کد آن همراه است.</p>
                  <p>پس این مهم است که وب سایت به روز و برای بیزینس در حال حاضر مشتری طراحی شده باشد که در این صورت سایت بسیار سبکتر و چابک تر می باشد و چون بیزینس مورد استفاده در نظر گرفته شده است ،در آینده امکانات جدید را به راحتی می توان به سایت اضافه نمود.</p>
                  <p>ودیگر این که شرکت هایی که سایت های از پیش آماده دارند، آمادگی لازم جهت واگذاری کد های وب سایت به مشتری را ندارند و از ارائه کد ها شانه خالی می کنند.</p>


                  <h1><strong>مراحل طراحی یک سایت شخصی عبارتند از:</strong></h1>
                  <h2><strong>ابتدا انتخاب نام دامنه حرفه ای:</strong></h2>
                  <p>اولین قدم برای راه اندازی وب سایت ثبت دامنه می باشد و در صورتی که نام دامنه به درستی انتخاب گردد تاثیر بسیار مثبتی در روند موفقیت وب سایت خواهد داشت. در حقیقت انتخاب نام دامنه مناسب و حرفه ای رسیدن به موفقیت را برای وب سایت ساده تر می سازد و پایه و اساس وب سایت را محکم می سازد. برای انتخاب نام دامنه مناسب و حرفه ای حتما می بایست با متخصص سئو و بهینه سازی وب سایت مشورت نمایید تا بهترین نام دامنه به شما پیشنها گردد. در نتیجه بدون مشورت با سئو کار اقدام به ثبت دامنه برای وب سایت خود ننمایید.</p>
                  <h2><strong>دوم انتخاب هاست:</strong></h2>
                  <p>هاست وب سایت تاثیر بسیاری در موفقیت وب سایت خواهد داشت و در صورتی که هاست با کیفیت مطلوبی تهیه نشود ممکن است تاثیر بسیار منفی در کسب و کار شرکت داشته باشد. هاست وب سایت می بایست سرعت مطلوبی داشته باشد و به درستی موارد پیکربندی و ایمن سازی در آن رعایت شده باشد. همچنین دقت نمایید از سرور معتبری هاستینگ خود را تهیه نمایید تا وب سایت شما دچار مشکل همسایه بد که باعث لطمه به سئو وب سایت می گردد نشود. در بین پکیج های شرکت های هاستینگ بهترین هاستینگ سرور اختصاصی می باشد که قیمت آن بسیار بالا است. پس از آن سرور مجازی گزینه مناسبی می باشد که قیمت آن به نسبت سرور اختصاصی مناسب تر است. در صورتی که بودجه شما به سرور اختصاصی و مجازی نمی رسد می توانید از سرورهای اشتراکی استفاده نمایید اما حتما در مورد کیفیت آن دقت نمایید و در تهیه سرور از افراد با سابقه در زمینه وب و همچنین متخصص سئو مشورت لازم را بگیرید.</p>
                  <h2><strong>سوم طراحی قالب سایت:</strong></h2>
                  <p>قالب سایت صورت وب سایت شماست و کاربران سایت را تحت تاثیر مثبت یا منفی قرار میدهد.</p>
                  <p><strong>برای انتخاب قالب دو راه در پیش دارید:</strong></p>
                  <p>راه اول وب سایتی را که از قبل می شناسید و ظاهر آن مورد تایید است به عنوان نمونه به شرکت پیشنهاد می دهید تا بر اساس پیکر بندی آن وب سایت شما طراحی شود.</p>
                  <p>راه دیگر این که نمونه اولیه از ظاهر سایت به شما داده می شود و شما تفییراتی که مد نظر دارید پیشنهاد می دهید و آن تغییرات در ظاهر سایت توسط تیم بیت کالا اعمال می شود.</p>
                  <p>&nbsp;</p>
                  <p><strong>انواع سبک های طراحی سایت وجود دارند برای مثال:</strong></p>
                  <h3><em><strong>طراحی دو بعدی</strong></em></h3>
                  <p>یکی از سبک های جدید امروزی طراحی دو بعدی می باشد که در این نوع طراحی دیگر از سایه ها و گوشه های گرد شده خبری نیست و قالب در ساده ترین شکل خود ارائه می گردد. به این نوع طراحی ها همچنین طراحی محتوا اول نیز گفته می شود زیرا مهترین دغدغه طراح سایت ارائه مطالب در بهترین روش ممکن است و بخش ها معمولا با تفاوت رنگی از یکدیگر جدا می گردند و از پالت رنگ های خاصی با نام رنگ های دو بعدی استفاده می گردد. ثابت شده طراحی دو بعدی تاثیر بهتری نسبت به طراحی های قدیمی بر روی کاربران دارد و کاربر وب سایت درک بهتری از وب سایت خواهد داشت.</p>
                  <h3><em><strong>طراحی تک صفحه ای:</strong></em></h3>
                  <p>یکی دیگر از سبک های جدید طراحی قالب وب سایت طراحی به صورت تک صفحه می باشد که در این روش صفحات اولیه وب سایت مانند درباره ما، تماس با ما، محصولات و ... در همان صفحه اصلی نمایش داده می شوند و کاربر پس از کلیک بر روی منوهای اصلی وب سایت به جای آنکه به صفحه دیگری وارد شود در صفحه اصلی به بخش مورد نظر اسکرول می گردد. این نوع طراحی ارزش صفحه اصلی وب سایت را بالا می برد زیرا کاربران مدت زمان بیشتری در صفحه اصلی وب سایت باقی می مانند و همین مسئله تاثیر بسیار مثبتی بر روی سئو وب سایت خواهد داشت.</p>
                  <h3><em><strong>یک سایت حرفه ای باید ریسپانسیو باشد:</strong></em></h3>
                  <p>سایت ریسپانسیو به نوعی وب سایت گفته می شود که خود را برای نمایش در سایزهای مختلف صفحه سازگار می نماید و برای رویت متون و مطالب وب سایت کاربر نیازی نیست در صفحه بزرگنمایی انجام دهد و یا از اسکرول چپ و راست استفاده نماید. با توجه به افزایش استفاده کنندگان از موبایل برای رویت وب سایت ها وجود نسخه موبایلی و ریسپانسیو سایت ها به امری ضروری تبدیل شده است. همچنین نسخه موبایلی یکی از فاکتورهای رنک دهی موتورهای جستجو نظیر گوگل می باشد بنابراین یک سایت حرفه ای حتما می بایست نسخه موبایلی داشته باشد. طراحی سایت ریسپانسیو در حقیقت یکی از مهترین فاکتورها در طراحی سایت حرفه ای می باشد.</p>
                  <h2><strong>چهارم اعمال سئو در سایت:</strong></h2>
                  <p>امروزه با توجه به افزایش تعداد کاربرانی که از اینترنت برای خرید کالا و خدمات خود استفاده می نمایند رعایت اصول سئو در سایت ها که باعث افزایش رتبه وب سایت در موتورهای جستجو می باشد بسیار ضروری می باشد. برای طراحی سایت سئو می بایست کد نویسی صفحات وب سایت بهینه سازی شده برای موتورهای جستجو باشد</p>
                  <h2><strong>پنجم محتوای سایت:</strong></h2>
                  <p>یک وب سایت برای آنکه حرفه ای به نظر رسید در کنار رعایت اصول و قواعد طراحی سایت می بایست محتوای خوب، کافی و با کیفیت داشته باشد تا کاربران پس از ورود به سایت با صفحه بی محتوا مواجه نگردد. در حقیقت یکی از مهترین مسائل در مورد موفقیت وب سایت وجود محتوای خوب و حرفه ای می باشد که این بخش بر عهده کارفرما می باشد که می بایست مطالب خوب، مفید و با کیفیت در زمینه شغلی خود تهیه نماید.</p>


                </div>
              </div>
              <ContactBitkala></ContactBitkala>
              <div class="container">
                <div class="maz_fulltext">
                  <h2>سوالات متداول:</h2>
                  <p><strong>برای داشتن وب سایت حرفه ای چه کاری باید انجام دهیم ؟</strong></p>
                  <p>مراحل در بالا توضیح داده شده است . می توانید برای اطلاعات بیشتر و مشاره رایگان برای ساخت سایت با ما تماس بگیرید : ۰۹۱۲۴۵۴۱۲۳۱</p>
                  <p><strong>تکنولوژی های مورد استفاده بیت کالا برای تهیه وب سایت چه می باشد ؟</strong></p>
                  <p>با توجه به نوع پروژه ، انتخاب تکنولوژی متفاوت است. در ادامه برخی از تکنولوژی های مورد استفاده ذکر می&nbsp; شوند.</p>
                  <p>استفاده از تکنولوژی &nbsp;Reactjs</p>
                  <p>استفاده از زبان فرامتنی قابل توسعه XML</p>
                  <p>استفاده از زبان های اسکریپت نویسی تحت کلاینت&nbsp;JAVASCRIPT&nbsp;و بهره گیری از&nbsp;JQUERY&nbsp;برای طراحی افکت ها و افزودن قابلیت های تعامل پذیری زیبا</p>
                  <p>استفاده از زبان های برنامه نویسی&nbsp;PHP,C#,MVC&nbsp;,&nbsp;ASP&nbsp;,&nbsp;NODE JS&nbsp;برای توسعه پنل های کارآمد.</p>
                  <p>استفاده از سرورهای لینوکس و ویندوز، که وابسته به زبان برنامه نویسی انتخابی دارد.</p>
                  <p>استفاده از دیتابیس&nbsp;MONGO&nbsp;,&nbsp;MYSQL&nbsp;,&nbsp;SQL SERVER&nbsp;,&nbsp;ORACLE&nbsp;بسته به میزان حجم مورد انتظار و سرعت مورد نیاز می باشد.</p>
                  <p>آیا قابلیت ارائه سورس کد های برنامه وجود دارد ؟</p>
                  <p>بله . هزینه ارائه سورس برنامه نسبت به نوع پروژه ها متفاوت می باشد.</p>
                  <p><strong>ما یک شرکت کوچک هستیم. حداقل هزینه طراحی وب سایت چقدر است ؟</strong></p>
                  <p>پایین ترین هزینه برای راه اندازی یک&nbsp; وب سایت&nbsp;۲ میلیون تومان می باشد.</p>
                  <p><strong>پشتیبانی رایگان شما بعد از تحویل پروژه چند ماه می باشد ؟</strong></p>
                  <p>دو ماه</p>
                  <p><strong>آیا آموزش پنل کاربری وب سایت بعد از تحویل پروژه رایگان است ؟</strong></p>
                  <p>بله. ارائه یک مرتبه آموزش کامل &nbsp;به نماینده کارفرما رایگان می باشد.</p>
                  <p><strong>شرکت دیگری برنامه ما را برنامه نویسی کرده و الان می خواهیم توسعه وب سایت را به بیت کالا بسپاریم. آیا امکان پذیر است ؟</strong></p>
                  <p>پس از بررسی سورس کدها و زیرساخت فنی ، امکان انجام آن معین و اعلام می شود.</p>
                </div>
              </div>
            </div>
          </ScrollAnimation>
        </div>


      </>
    )
  }
}


